import * as React from "react";

import { EnquiryContext } from "./context/EnquiryState";

const callTimes = [
	"Anytime",
	"Morning",
	"Afternoon",
	"Evening",
]

const activeAdditionalButton = 'button bg-skin-cacti font-semibold text-black border-2 border-skin-cacti';
const inactiveAdditionalButton = 'button border-2 border-skin-cacti text-black font-semibold';

export const ParentDetailsComponent = () => {

	const {
		state,
		dispatch,
		TrackAnalyticsEvent
	} = React.useContext(EnquiryContext)

	React.useEffect(() => {
		dispatch({ type: "SET_FORM_COMPONENT", payload: "parentDetails" })
		TrackAnalyticsEvent("parent-details")
	}, [])

	const SelectAdditional = (item) => {
		let clonedForm = state.form
		clonedForm[item] = !clonedForm[item]

		// If an enquiry item is being selected and there is an existing error then clear it
		// OR if we are deselecting Other and there is an existing error then clear it
		if ((clonedForm[item] && !!state.parentErrors.enquiryDetails) || (!clonedForm[item] && item == 'additionalOther' && !!state.parentErrors.enquiryDetails)) {
			let clonedErrors = state.parentErrors
			clonedErrors.enquiryDetails = null
			dispatch({ type: "UPDATE_PARENT_ERRORS", payload: clonedErrors })
		}

		dispatch({ type: "UPDATE_FORM", payload: clonedForm })
	}

	const SetField = (event, label) => {
		// Error checking
		let clonedForm = state.form
		let input = event.target.value
		let errors = state.parentErrors

		switch (label) {
			case 'parentFullName':
				if (input == null || input == '') {
					errors[label] = { message: "Please enter your full name" }
				} else {
					errors[label] = null
				}
				break;
			case 'email':
				let emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (input == null || input == '' || !emailPattern.test(input.toLowerCase())) {
					errors[label] = { message: "Please enter a valid email address" }
				} else {
					errors[label] = null
				}
				break;
			case 'contactNumber':
				let phonePattern = /^[0]([0-9]\s*){9}$/;
				if (input == null || input == '' || !phonePattern.test(input)) {
					errors[label] = { message: "Please enter a valid phone number" }
				} else {
					errors[label] = null
				}
				break;
		}

		clonedForm[label] = input

		dispatch({ type: "UPDATE_FORM", payload: clonedForm })
		dispatch({ type: "UPDATE_PARENT_ERRORS", payload: errors })
	}

	return (
		<React.Fragment>

			<div className="my-6 font-semibold text-xl">
				Tell us about you
			</div>

			{/*Name Input*/}
			<div className="mb-6">
				<label htmlFor="ParentFullName" className="block text-xs font-medium text-gray-700">FIRST AND LAST NAME <span className="text-red-400">*</span></label>
				<div className="mt-1 relative rounded-md shadow-sm">
					<input
						onBlur={() => SetField(event, 'parentFullName')}
						defaultValue={state.form?.parentFullName}
						type="text"
						name="ParentFullName"
						className="enquiry-input"
						placeholder="Enter your full name"
						aria-invalid="true"
						aria-describedby="ParentFullName" />

					{!!state.parentErrors?.parentFullName ?
						<div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
							{/*Icon*/}
							<svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
								<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
							</svg>
						</div>
						:
						null
					}
				</div>

				{!!state.parentErrors?.parentFullName ?
					<p className="mt-2 text-xs text-red-600">{state.parentErrors.parentFullName.message}</p>
					:
					null
				}
			</div>

			{/*Email Input*/}
			<div className="mb-6">
				<label htmlFor="email" className="block text-xs font-medium text-gray-700">EMAIL <span className="text-red-400">*</span></label>
				<div className="mt-1 relative rounded-md shadow-sm">
					<input
						onBlur={() => SetField(event, 'email')}
						defaultValue={state.form?.email}
						type="email"
						name="email"
						className="enquiry-input"
						placeholder="email@domain.com"
						aria-invalid="true"
						aria-describedby="email-error" />

					{!!state.parentErrors?.email ?
						<div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
							{/*Icon*/}
							<svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
								<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
							</svg>
						</div>
						:
						null
					}
				</div>

				{!!state.parentErrors?.email &&
					<p className="mt-2 text-xs text-red-600">{state.parentErrors.email.message}</p>
				}
			</div>

			{/*Phone Input*/}
			<div className="mb-6">
				<label htmlFor="ContactNumber" className="block text-xs font-medium text-gray-700">PHONE NUMBER <span className="text-red-400">*</span></label>
				<div className="mt-1 relative rounded-md shadow-sm">
					<input
						onBlur={() => SetField(event, 'contactNumber')}
						defaultValue={state.form?.contactNumber}
						type="text"
						name="ContactNumber"
						className="enquiry-input"
						placeholder="04xx..."
						aria-invalid="true"
						aria-describedby="ContactNumber-error" />

					{!!state.parentErrors?.contactNumber ?
						<div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
							{/*Icon*/}
							<svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
								<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
							</svg>
						</div>
						:
						null
					}
				</div>

				{!!state.parentErrors?.contactNumber ?
					<p className="mt-2 text-xs text-red-600">{state.parentErrors.contactNumber.message}</p>
					:
					null
				}

			</div>

			{/*Time To Call Dropdown*/}
			{/*<div className="mb-6">*/}
			{/*	<label htmlFor="BestTimeToCall" className="block text-xs font-medium text-gray-700">BEST TIME TO CALL</label>*/}
			{/*	<select*/}
			{/*		onChange={() => SetField(event, 'bestTimeToCall')}*/}
			{/*		name="BestTimeToCall"*/}
			{/*		className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"*/}
			{/*	>*/}
			{/*		{callTimes.map(time => {*/}
			{/*			return <option selected={time == state.form?.bestTimeToCall}>{time}</option>*/}
			{/*		})}*/}
			{/*	</select>*/}
			{/*</div>*/}

		</React.Fragment >
	);

}